module.exports = __webpack_public_path__ + "img/7.0c3f87c4.jpg";